export const isFalsy = (value: any) =>
  value === false || value === '' || value === null || value === undefined
